import { Injectable } from '@angular/core';

@Injectable()
export class AuthService {
  constructor() { }

  /**
   * Checks is the user is authenticated.
   * @return {boolean} True if the user is authenticated.
   */
  isAuthenticated(): boolean {
    const userId = localStorage.getItem('userId');
    if (userId) { // Check whetherwe have userId for authentication
      return true;
    } else {
      return false;
    }
  }
}
